import { Market } from "../../models/Market";
import { SelectionParser } from "../SelectionParser";
import { Selection } from "../../models/Selection";
import { SelectionType } from "../../helpers/enum";
import { LineGroup, EventLiveLegacy } from "sb-resp-lib";
import { EventPreliveLegacy } from "../../../../../interfaces";

export class MarketParser {

    public static ParseEvent(event: EventLiveLegacy | EventPreliveLegacy): Market[] {

        let markets : Market[] = [];
        let qaSelections: Selection[] = [];
        let ouSelections: Selection[] = [];
        let hasML, hasfirstHC, hasfirstOU;
        let isQA: boolean = event["isQA"] ? event["isQA"] : false;
        let ouLineGroupId: string = "";

        for (let id = 0; id < Object.keys(event.Lines || []).length; id += 1) {
            let line = event.Lines[Object.keys(event.Lines)[id]];

            hasML = MarketParser.addMLMarket(hasML, line, isQA, markets, event);
            hasfirstHC = MarketParser.addHCMarket(hasfirstHC, line, isQA, markets, event);

            ({ hasfirstOU, ouLineGroupId, ouSelections } = MarketParser.getOUSelections(hasfirstOU, line, ouLineGroupId, ouSelections));

            if (line.Odds) {
                qaSelections = qaSelections.concat(SelectionParser.LineGroupParse(line, SelectionType.QA));
            }
        }

        MarketParser.addOUMarket(isQA, ouLineGroupId, ouSelections, markets, event)
        MarketParser.addQAMarket(isQA, qaSelections, markets, event);

        return markets;
    }

    private static getOUSelections(hasfirstOU: any, line: any, ouLineGroupId: string, ouSelections: Selection[]) {
        if ((!hasfirstOU && line.OU) || (line.OU && line.OU.Points1 === 2.5)) {
            hasfirstOU = true;
            ouLineGroupId = line.ID;
            ouSelections = SelectionParser.LineGroupParse(line, SelectionType.OU);
        }
        return { hasfirstOU, ouLineGroupId, ouSelections };
    }

    private static addQAMarket(isQA: boolean, qaSelections: Selection[], markets: Market[], event: EventLiveLegacy | EventPreliveLegacy) {
        if (isQA && qaSelections.length > 0) {
            markets.push(new Market({
                id: event.ID.toString(),
                typeID: event.Type.toString(),
                typeName: event.TypeName ? event.TypeName : "",
                isQA,
                selections: qaSelections
            }));
        }
    }

    private static addMLMarket(hasML: boolean, line: LineGroup, isQA: boolean, markets: Market[], event: EventLiveLegacy | EventPreliveLegacy) {
        if (!hasML && line.ML) {
            let mlSelections = SelectionParser.LineGroupParse(line, SelectionType.ML);
            if (mlSelections.length > 0)
            {
                hasML = true;
                markets.push(new Market({
                    id: event.ID.toString() + "_1",
                    typeID: event.Type.toString() + "_1",
                    typeName: event.TypeName ? event.TypeName : "",
                    isQA,
                    lineGroupID: line.ID,
                    selections: SelectionParser.LineGroupParse(line, SelectionType.ML)
                }));
            }
        }
        return hasML;
    }

    private static addOUMarket(isQA: boolean, lineGroupID: string, ouSelections: Selection[], markets: Market[], event: EventLiveLegacy | EventPreliveLegacy) {

        if (ouSelections.length > 0 && lineGroupID !== "")
        {
            markets.push(new Market({
                    id: event.ID.toString() + "_3",
                    typeID: event.Type.toString() + "_3",
                    typeName: event.TypeName ? event.TypeName : "",
                    isQA,
                    lineGroupID,
                    selections: ouSelections
            }));
        }
    }

    private static addHCMarket(hasfirstHC: boolean, line: LineGroup, isQA: boolean, markets: Market[], event: EventLiveLegacy | EventPreliveLegacy) {
        if (!hasfirstHC && line.Spread) {
            let hcSelections = SelectionParser.LineGroupParse(line, SelectionType.HC);
            if (hcSelections.length > 0) {
                hasfirstHC = true;
                markets.push(new Market({
                    id: event.ID.toString() + "_2",
                    typeID: event.Type.toString() + "_2",
                    typeName: event.TypeName ? event.TypeName : "",
                    isQA,
                    lineGroupID: line.ID,
                    selections: hcSelections
                }));
            }
        }
        return hasfirstHC;
    }
}